module.exports = __webpack_public_path__ + "static/media/play.14a699e7.svg";